import { logout } from '@bighealth/api/UserAccountAuthorization/v1';

import { getQueryClient } from 'components/ProvidersContainer/getQueryClient';

export const queryClientLogout = async (): Promise<logout.Response> => {
  return await getQueryClient().fetchQuery(logout.queryKey, () => logout());
};
